import { memo, PropsWithChildren } from 'react';
import { useInView } from 'react-intersection-observer';

export const FilterItemWrapper = memo(({ children }: PropsWithChildren) => {
    const { ref, inView } = useInView({
        threshold: 1,
        triggerOnce: true,
    });

    return (
        <div className="vss-filter-item-wrapper" ref={ref}>
            {inView && children}
        </div>
    );
});
